"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const internal_1 = require("./internal");
exports.convertNumericIdToAddress = (numericId) => {
    if (numericId === undefined ||
        numericId === null ||
        numericId.trim().length === 0) {
        return undefined;
    }
    const plainString10 = [], codeword = internal_1.initialCodeword.slice();
    let pos = 0;
    let length = numericId.length;
    for (let i = 0; i < length; i++) {
        plainString10[i] = numericId.charCodeAt(i) - '0'.charCodeAt(0);
    }
    let digit32 = 0, newLength = 0;
    do {
        digit32 = 0;
        newLength = 0;
        for (let i = 0; i < length; i++) {
            digit32 = digit32 * 10 + plainString10[i];
            if (digit32 >= 32) {
                plainString10[newLength] = digit32 >> 5;
                digit32 &= 31;
                newLength++;
            }
            else if (newLength > 0) {
                plainString10[newLength] = 0;
                newLength++;
            }
        }
        length = newLength;
        codeword[pos] = digit32;
        pos++;
    } while (length > 0);
    const p = [0, 0, 0, 0];
    for (let i = internal_1.base32Length - 1; i >= 0; i--) {
        const fb = codeword[i] ^ p[3];
        p[3] = p[2] ^ internal_1.gmult(30, fb);
        p[2] = p[1] ^ internal_1.gmult(6, fb);
        p[1] = p[0] ^ internal_1.gmult(9, fb);
        p[0] = internal_1.gmult(17, fb);
    }
    codeword[13] = p[0];
    codeword[14] = p[1];
    codeword[15] = p[2];
    codeword[16] = p[3];
    let out = internal_1.AddressPrefix + '-';
    for (let i = 0; i < 17; i++) {
        out += internal_1.alphabet[codeword[internal_1.cwmap[i]]];
        if ((i & 3) === 3 && i < 13) {
            out += '-';
        }
    }
    return out;
};
//# sourceMappingURL=convertNumericIdToAddress.js.map